import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setPortal } from 'modules/portal';
import { makeHeadData, makeRowColumn } from 'lib/commonLib';
import { paramConverter } from 'modules/common';
import { getCustom } from 'lib/api/common';
import { issueReport } from 'lib/api/report';
import { userOnLogin } from 'lib/api/user';

import CurrentStatus from 'components/atoms/CurrentStatus';
import NewButton from 'components/molecules/NewButton';
import ContentsWrap from 'components/molecules/ContentsWrap';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';

const SiteButtonList = ({ data, setSnackbar }) => {
  const { t } = useTranslation();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const { URL, ADVER_ID } = data;
  const dispatch = useDispatch();
  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = {
      url: url,
      cnt: popIndex,
    };

    dispatch(setPortal(newPortal));
  };

  /**
   * 로그인처리
   */
  const handleOnLogin = (ADVER_ID) => {
    userOnLogin(ADVER_ID, 'manage')
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          handlePortalUrl(data.url);
        } else {
          alert('로그인에 실패했습니다. 관리자에게 문의하세요.');
        }
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          variant: 'error',
          message: error,
        });
      });
  };

  return (
    <IconAreaWrap text={data.SITE_NAME}>
      <NewButton
        title={t('광고주 로그인')}
        iconBtn
        icon="faSignInAlt"
        onClick={(e) => handleOnLogin(ADVER_ID)}
        disableRipple
      />
      <NewButton
        title={t('광고주 통계')}
        iconBtn
        icon="faUserChart"
        onClick={(e) =>
          handlePortalUrl(
            '/report/daily/par?adverId=' +
              ADVER_ID +
              '&uri=/report/daily/par&isPop=1&popGroup=adverStatistics'
          )
        }
        disableRipple
      />
      <NewButton
        title={t('사이트로 이동')}
        iconBtn
        icon="faHome"
        onClick={(e) => handlePortalUrl('http://' + URL)}
        disableRipple
      />
    </IconAreaWrap>
  );
};

const IssueStatistics = () => {
  let initParams = {
    pltfomTpCode: 'all',
    contact: 'all',
    gubun: 11,
  };
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [list, setList] = useState({});
  const [loading, setLoading] = useState(true);
  const [tableHead, setTableHead] = useState([]);
  let initSnackbar = {
    open: false,
    variant: 'success',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);

  const tableInfoJson = {
    ADVRTS_AMT: {
      headList: [
        {
          id: 'SITE_NAME',
          label: '사이트',
          orderFlag: true,
          type: 'string',
          format: '@',
          displayFlag: true,
        },
        {
          id: 'Y_ADVRTS_AMT',
          label: '어제',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
          displayFlag: true,
        },
        {
          id: 'W_ADVRTS_AMT',
          label: '평일(5일)',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
          displayFlag: true,
        },
        {
          id: 'ADVRTS_AMT_RAF',
          label: '등락률',
          orderFlag: true,
          type: 'number',
          format: '0.00%',
          displayFlag: true,
        },
      ],
      sort: 'desc',
      order: 'SITE_NAME',
    },
    ROAS: {
      headList: [
        {
          id: 'SITE_NAME',
          label: '사이트',
          orderFlag: true,
          type: 'string',
          format: '@',
          displayFlag: true,
        },
        {
          id: 'Y_ROAS',
          label: '어제',
          orderFlag: true,
          type: 'number',
          format: '0.00%',
          displayFlag: true,
        },
        {
          id: 'W_ROAS',
          label: '평일(5일)',
          orderFlag: true,
          type: 'number',
          format: '0.00%',
          displayFlag: true,
        },
        {
          id: 'ROAS_RAF',
          label: '등락률',
          orderFlag: true,
          type: 'number',
          format: '0.00%',
          displayFlag: true,
        },
      ],
      sort: 'desc',
      order: 'SITE_NAME',
    },
    NEW_ADVER: {
      headList: [
        {
          id: 'SITE_NAME',
          label: '사이트',
          orderFlag: true,
          type: 'string',
          format: '@',
          displayFlag: true,
        },
        {
          id: 'Y_ADVRTS_AMT',
          label: '어제',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
          displayFlag: true,
        },
        {
          id: 'POINT',
          label: '잔액',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
          displayFlag: true,
        },
        {
          id: 'JOIN_DTTM',
          label: '가입 일자',
          orderFlag: true,
          type: 'date',
          format: 'yyyy-mm-dd',
          displayFlag: true,
        },
      ],
      sort: 'desc',
      order: 'SITE_NAME',
    },
    BDGT: {
      headList: [
        {
          id: 'SITE_NAME',
          label: '사이트',
          orderFlag: true,
          type: 'string',
          format: '@',
          displayFlag: true,
        },
        {
          id: 'BUDGET_LIMIT',
          label: '에산 한도',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
          displayFlag: true,
        },
        {
          id: 'Y_ADVRTS_AMT',
          label: '어제',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
          displayFlag: true,
        },
        {
          id: 'W_ADVRTS_AMT',
          label: '평일(5일)',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
          displayFlag: true,
        },
      ],
      sort: 'desc',
      order: 'SITE_NAME',
    },
    STOP_ADVER: {
      headList: [
        {
          id: 'SITE_NAME',
          label: '사이트',
          orderFlag: true,
          type: 'string',
          format: '@',
          displayFlag: true,
        },
        {
          id: 'POINT',
          label: '잔액',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
          displayFlag: true,
        },
      ],
      sort: 'desc',
      order: 'SITE_NAME',
    },
  };

  /**
   * 테이블 나오는 순서
   */
  const tableOrder = [
    { key: 'ADVRTS_AMT', label: '지출' },
    { key: 'ROAS', label: 'ROAS' },
    { key: 'BDGT', label: '일예산' },
    { key: 'STOP_ADVER', label: '중지 광고주' },
    { key: 'NEW_ADVER', label: '신규 런칭' },
  ];

  useEffect(() => {
    getCustom({
      layoutName: 'layout',
    })
      .then((response) => {
        const { data } = response.data;
        const result = new Map();
        // Map 으로 변경 및 데이터 가공
        // 테이블 나오는 순서대로 이슈설정 리스트에 넣어줌
        for (let i = 0; i < tableOrder.length; i++) {
          const curData = tableOrder[i];
          const { key } = curData;
          result.set(key, {
            ...curData,
            id: curData.key,
            displayFlag: data[key].display,
          });
        }
        setTableHead(result);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          variant: 'error',
          message: error,
        });
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setLoading(true);
    issueReport({
      ...paramConverter(params),
    })
      .then((response) => {
        const {
          ADVRTS_AMT = { data: [] },
          BDGT = { data: [] },
          NEW_ADVER = { data: [] },
          ROAS = { data: [] },
          STOP_ADVER = { data: [] },
        } = response.data.data;

        setList({
          ADVRTS_AMT: ADVRTS_AMT.data,
          BDGT: BDGT.data,
          NEW_ADVER: NEW_ADVER.data,
          ROAS: ROAS.data,
          STOP_ADVER: STOP_ADVER.data,
        });
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          variant: 'error',
          message: error,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params]);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const customized = {
    SITE_NAME: {
      makeBody: (rowObj) => {
        return (
          <>
            <SiteButtonList data={rowObj} setSnackbar={setSnackbar} />
          </>
        );
      },
    },
    ADVRTS_AMT_RAF: {
      makeBody: (rowObj) => {
        let color;
        if (Math.sign(rowObj.ADVRTS_AMT_RAF) === 1) {
          color = { color: 'blue' };
        } else {
          color = { color: 'red' };
        }
        return (
          <>
            <p style={color}>
              {makeRowColumn(rowObj.ADVRTS_AMT_RAF, 'number', '0.00%')}
            </p>
          </>
        );
      },
    },
    ROAS_RAF: {
      makeBody: (rowObj) => {
        let color;
        if (Math.sign(rowObj.ADVRTS_AMT_RAF) === 1) {
          color = { color: 'blue' };
        } else {
          color = { color: 'red' };
        }
        return (
          <p style={color}>
            {makeRowColumn(rowObj.ROAS_RAF, 'number', '0.00%')}
          </p>
        );
      },
    },
    JOIN_DTTM: {
      makeBody: (rowObj) => {
        return makeRowColumn(
          rowObj.JOIN_DTTM.split(' ')[0],
          'date',
          'yyyy-mm-dd'
        );
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
      message: '',
    });
  };

  return (
    <>
      <NewFilterWrap loading={loading} handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDate={false}
          useExternalFilter={false}
          useManagerFilter
        />
      </NewFilterWrap>
      {loading ? (
        <CurrentStatus type="loading" option="useMinHeight" />
      ) : (
        <ContentsWrap contentsCount={2}>
          {
            /**
             * 디스플레이 여부로 테이블 리턴
             */
            tableHead.size !== 0 &&
              (() => {
                const result = [];
                for (let i = 0; i < tableOrder.length; i++) {
                  const { key, label } = tableOrder[i];
                  const curData = tableHead.get(key);
                  const tableInfo = tableInfoJson[key];

                  if (curData.displayFlag) {
                    result.push(
                      <div key={i}>
                        <NewTableContainer
                          params={{
                            ...params,
                            sort: tableInfo.sort,
                            order: tableInfo.order,
                          }}
                          getParam={getParam}
                          customized={customized}
                          useSearch={false}
                          useExcel={false}
                          useTotal={false}
                          useFetch={false}
                          propsList={list[key]}
                          propsHeadCells={makeHeadData(tableInfo.headList)}
                          useCustomTable
                          title={label}
                          rowsPerPage={5}
                          loading={loading}
                        />
                      </div>
                    );
                  }
                }
                return result;
              })()
          }
        </ContentsWrap>
      )}
      <SnackbarWrap
        open={snackbar.open}
        onClose={handleSnackBarClose}
        variant={snackbar.variant}
        message={snackbar.message}
      />
    </>
  );
};

export default IssueStatistics;
